var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.onboard},[_c('pt-icon',{attrs:{"icon":_vm.icon,"icon-style":{
            width: '250px',
            height: '250px'
        }}}),_c('p',[_vm._t("default")],2),_c('router-link',{attrs:{"to":{ name: _vm.toRouterName }}},[_c('pt-button',{class:_vm.$style.btn,attrs:{"size":"medium"}},[_vm._v(_vm._s(_vm.BtnText))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }